// @flow
import componentLoader from 'app/packages/react-router-v3-component-loader';
import store from 'app/common/redux/store/singleton';
import type { PromiseLoader } from 'app/common/lib/ReactRouter/types';
import { pageBundleLoadComplete } from 'app/common/redux/actions/loadingBar';

const getImportsFrom = (filename: string) => ({
  loader,
  path,
  name,
}: {|
  loader: PromiseLoader,
  name: string,
  path: string,
|}) => {
  const getComponent = () =>
    loader().then((Component) => {
      if (!__SERVER__) {
        store.instance.dispatch(pageBundleLoadComplete());
      }
      const defaultExport = Component.default;
      if (__SERVER__ && process.env.RUNNING_ON_DEVSERVER && !defaultExport) {
        // eslint-disable-next-line no-console
        console.error(
          `Failed to resolve default export from ${path}, most likely due to uncaught JS exceptions. Consider importing ${path} statically for a more friendly error message.`,
        );
      }
      return defaultExport;
    });

  return {
    loader,
    // $FlowFixMe: New error after Flow Upgrade http://pinch.pinadmin.com/flow53upgdoc
    getComponent: componentLoader(getComponent, path),
    chunkName: name,
  };
};

export default getImportsFrom;
